import { render, staticRenderFns } from "./MsgObject.vue?vue&type=template&id=670cc838&scoped=true"
import script from "./MsgObject.vue?vue&type=script&lang=js"
export * from "./MsgObject.vue?vue&type=script&lang=js"
import style0 from "./MsgObject.vue?vue&type=style&index=0&id=670cc838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670cc838",
  null
  
)

export default component.exports